import { Box, styled } from "@mui/material";

export const SelectionCardIconBox = styled(Box)(() => ({
  display: "flex",
  "& .MuiSvgIcon-root": {
    height: "64px",
    width: "64px",
    fill: "none",
    padding: "4px",
  },
}));

export const SelectionCardContentBox = styled(Box)(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontWeight: "600",
  paddingLeft: "12px",
  display: "flex",
  alignItems: "center",
}));
